<template>
  <div>
    <div id="header-container" class="pl-5">
      <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
      <div class="pt-4 text-white">
        <h3 class="text-white">{{ $t('System Configuration') }}</h3>
        <!-- <span class="fz-16 fw-400">Lorem ipsum dolor, sit amet consectetur adipisicing elit.</span> -->
      </div>
    </div>
    <b-container fluid class="pb-5">
      <div id="body-container">
        <b-row>
          <b-col xs="12" md="6" offset-md="3" class="p-3 mt-1 mb-4">  
              
              <div class="form-group mb-2 mt-3">
                <div class="fz-18 fw-800 mb-2">{{ $t('Default Language') }}</div>
                <select name="language" v-model="selected_language" class="form-control language mb-4">
                  <option v-for="(item,index) in language_list" :value="index" :delected="index==selected_language" v-if="index!='my-MY'" :key="index">{{$t(item)}}</option>
                </select>
              </div>
              <base-button type="primary" native-type="button" class="mb-2 fz-20 fw-700 w-100" @click="setLanguage($event)">{{ $t('Save') }}</base-button>
              <!-- <base-button type="outline-danger" native-type="button" class="mb-2 fz-20 fw-700 w-100" @click="setLogout($event)">{{ $t('Logout') }}</base-button> -->
          
          </b-col>
        </b-row>
      </div>
    </b-container>
   
  </div>
</template>
<script>
  import Vue from 'vue'
  import Common from "@/services/Common";

  export default {
    name: 'system-configuration',
    data() {
      return {
        translation     : process.env.VUE_APP_TRANSLATION,
        language_list:{
          "en-EN":"English",
          "zh-CN":"Simplified Chinese",
          "zh-TW":"Traditional Chinese"
        },
        selected_language : ''
      };
    },
    methods: {
      setLanguage(event){
        if(this.translation==1){
          localStorage.setItem("lang",this.selected_language);
          localStorage.setItem("lang-key",this.selected_language);
          this.$i18n.locale = this.selected_language;
          
          const self = this;

          Common.set_language({"language":localStorage.getItem("lang-key")}).then(response => {
            if(response.status == 200 && response.data.success){
              self.$notify({type: 'success', text: self.getMessage('Successfully change default language')});
              setTimeout(function(){
                location.reload();
              },500);
            }
          })
        }
      },
      getMessage: function (key) {
        return this.$t(key)
      },
      setLogout(event){
        localStorage.removeItem("token");
        localStorage.removeItem("member");
        localStorage.removeItem("isFirstTime");
        
        window.parent.location.href = location.protocol+"//"+window.location.hostname;
      }
    },
    mounted(){
      if(this.translation==1){
        this.selected_language = localStorage.getItem("lang")?localStorage.getItem("lang"):"";
      
        Common.get_language().then(response => {
          if(response.status == 200 && response.data.success){
            this.language_list = response.data.data;
            let checked = false;
            Object.keys(this.language_list).forEach((key)=>{
              if(key==this.current_lang){
                checked = true;
              }
            });
            if(!checked){
              localStorage.setItem("lang-key","en-EN");
              localStorage.setItem("lang","en-EN");
            }
          }
        });
      }
      else{
        this.selected_language = "en-EN";
      }
    }
  };
</script>
<style></style>
